import * as DateFns from "date-fns"

type DateFormat =
  | "EEE do MMM yyyy" // Wed 13th Aug 2025
  | "EEE do MMM" // Wed 13th Aug

// Add more as and when needed

export const formatToDate = (
  date: Date,
  format?: DateFormat
) =>
  format
    ? DateFns.format(date, format)
    : DateFns.format(date, "EEE do MMM")
